var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"btn",class:[
    ("btn-size_" + _vm.size),
    ("btn-type_" + _vm.type),
    {
      'btn-fill': _vm.fill,
      'btn_icon-btn': !!_vm.icon,
      'btn-overlay': _vm.overlay,
      'btn-max': _vm.max,
      'btn-loading': _vm.loading,
      'btn-rewrite-color': !!_vm.rewriteColor,

      btn_disabled: _vm.disabled,
    },
    ("btn-custom-color_" + _vm.customColor) ],style:(_vm.cssProps),attrs:{"id":_vm.id,"disabled":_vm.disabled,"type":_vm.actionType}},_vm.$listeners),[_c('div',{staticClass:"btn-container flex-centering"},[_c('Spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],attrs:{"size":_vm.size,"color":_vm.spinnerColor}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"d-contents"},[_c(_vm.leftIconComponent,{tag:"component",staticClass:"btn-icon btn-icon_left"}),_c(_vm.onlyIcon,{tag:"component",staticClass:"btn-icon btn-icon_center",class:{ 'btn-icon_rotated': _vm.reverseIcon }}),_vm._t("default"),_c(_vm.rightIconComponent,{tag:"component",staticClass:"btn-icon btn-icon_right"})],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }